import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

const SkeletonLoading = ({ num = 2 }) => {
  const arr = new Array(num).fill('i')

  return (
    <>
      {arr.map((_val, index) => (
        <Stack
          key={index}
          spacing={1}
          direction="row"
          alignItems={'center'}
          sx={{
            borderBottom: index === arr.length - 1 ? '' : '1px solid #E5E5E5',
            px: '14px',
            py: '16px',
          }}
        >
          <Skeleton variant="circular" width={45} height={45} />
          <Stack spacing={1}>
            <Skeleton variant="rounded" width={250} height={22} />
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
          </Stack>
        </Stack>
      ))}
    </>
  )
}

export default SkeletonLoading
